import styled from 'styled-components'

export const Iframe = styled.iframe`
  border: 0;
  height: 1250px;
  width: 100%;
`
